import env from '../env.js'
import { getUserData } from '@/helpers/utils'

const state = {
    isLoading: false,
    AppActiveUser: getUserData(),
    domain: env.domain,
    localUserKey: env.localUserKey,
    appName: env.appName,
    config:{
        shortDesc: "Arise Youth Employment Portal",
        appEmail: "support@employment.akwaibomstate.gov.ng"
    },
    scrollY: 0,
    windowWidth: window.innerWidth,
    countries: [],
    localGovernments: [],
    banks:[],
    dashboardData:{
        "unread_notifications": 0,
        "user": {},
        "candidate": {},
        "opportunities": {},
        "incomplete_profile_logs": [],
        "ask_to_complete_profile": false,
        "force_profile_update": false,
        "force_update_marital_status": false
    },
    lightbox:{
        index: null,
        visible: false,
        files: []
    },
    pdfModalFrame:{
        visible: false,
        filePath: ""
    },
}

export default state
